// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ok-0";
export var discountCodeInput = "_ok-1";